/* api-dates.js - Availability via https://api.myselfie.com/public/v1/{shop}/bookedDatesAvailability
   - Single-date enforcement:
       - If the CART has a date -> lock datepicker to that date (read-only)
       - User selections alone DO NOT lock the picker
       - Any cart date mismatch -> auto-clear cart (no prompt)
   - Datepicker is NEVER globally disabled; fixed-date SKUs hide the picker, otherwise we lock input only (from cart)
   - Aggregate.sold_out blocks a day; Aggregate.low tints the day background (subtle)
   - Per-product availability, Printer (MYP) overrides Myselfie
   - Pricing cards (.pricing-card[data-sku]) toggle .sold-out / .low-capacity for selected date
   - Per-key limits via PRODUCT_MAP; bundles count toward each key they include
   - Redirects only for pure Myselfie (M- only, no '+', no D-)
*/

/* ==========================
   EASY PRODUCT MAPPING
   - prefixes: array of case-insensitive prefixes for SKU parts
   - key: must match payload.products[key] from the API
   - limit: per-cart quantity cap (null => no cap)
   - requiresDate: category requires a date (besides fixed D-)
   - overrides.ignoreFor: if this key is present, ignore sold-out for listed keys
   ========================== */
var PRODUCT_MAP = [
  { prefixes: ["M-"],   key: "Myselfie",    limit: 5, requiresDate: true,  overrides: { ignoreFor: [] } },
  { prefixes: ["MYG"],  key: "Mygreetings", limit: 5, requiresDate: true,  overrides: { ignoreFor: [] } },
  { prefixes: ["MYP"],  key: "Printer",     limit: 5, requiresDate: false, overrides: { ignoreFor: ["Myselfie"] } },
  { prefixes: ["GAL-"], postfixes: ["-SA"], key: "GallerySA", limit: null, requiresDate: true, overrides: { ignoreFor: [] } }
  // Add new products here
];

(function () {
  var $ = window.jQuery;
  // jQuery UI is only needed for the product page's own picker. The pricing-card
  // and cart logic below must keep working without it (e.g. on the home page,
  // where the global header picker in assets/myselfie-header.js drives the cards).
  var HAS_JQUERY_UI = !!($ && $.datepicker);
  if (!HAS_JQUERY_UI) {
    console.warn("[api-dates] jQuery UI datepicker not found - product-page picker disabled.");
  }

  var DATE_INPUT_SELECTOR = "#productpage-booking-start";
  var API_FMT = "yy-mm-dd"; // yyyy-mm-dd for jQuery UI
  var LOCK_FLAG = "wdn_bookingdate_locked"; // sessionStorage flag (set only when cart has a date)

  function keyConfig(key){ return PRODUCT_MAP.find(function(p){ return p.key===key; }); }
  function isCartPage() {
    return /\/cart(\/|$|\?|#)/.test(location.pathname) ||
           document.body.classList.contains("template-cart");
  }

  // ---- date helpers ----
  function pad2(n){return (n<10?"0":"")+n;}
  function ddmmyyToIso(s){ if(!s) return ""; var a=s.split("/"); if(a.length!==3) return ""; return a[2]+"-"+a[1]+"-"+a[0]; }
  function dateToDdMmYy(d){ return pad2(d.getDate())+"/"+pad2(d.getMonth()+1)+"/"+d.getFullYear(); }
  function dateToIso(d){ return d.getFullYear()+"-"+pad2(d.getMonth()+1)+"-"+pad2(d.getDate()); }
  function parseDdMmYyyyToDate(s){ var m=/^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s); if(!m) return null; return new Date(+m[3],+m[2]-1,+m[1]); }
  function isoToMs(iso){ return Date.parse(iso); }

  // ---- SKU helpers (PRODUCT_MAP aware) ----
  var SKU = {
    prefixToKey: function(part){
      if(!part || typeof part!=="string") return null;
      var U = part.trim().toUpperCase();
      for (var i=0;i<PRODUCT_MAP.length;i++){
        var cfg = PRODUCT_MAP[i];
        for (var j=0;j<cfg.prefixes.length;j++){
          var pref = String(cfg.prefixes[j]).toUpperCase();
          if (U.startsWith(pref)) {
            if (cfg.postfixes && cfg.postfixes.length) {
              for (var k=0;k<cfg.postfixes.length;k++) {
                if (U.endsWith(String(cfg.postfixes[k]).toUpperCase())) return cfg.key;
              }
            } else {
              return cfg.key;
            }
          }
        }
      }
      return null;
    },
    fromSku: function(sku){
      if(!sku || typeof sku!=="string") return [];
      var set = new Set();
      sku.split("+").forEach(function(p){ var k=SKU.prefixToKey(p); if(k) set.add(k); });
      return Array.from(set);
    },
    fixedDateFromSku: function(sku){
      if(!sku || typeof sku!=="string") return null;
      var parts = sku.split("+");
      for (var i=0;i<parts.length;i++){
        var p = parts[i].trim();
        var m = /^D-(\d{2}\/\d{2}\/\d{4})$/i.exec(p);
        if (m){ var d=parseDdMmYyyyToDate(m[1]); if(d && !isNaN(d)) return d; }
      }
      return null;
    }
  };

  // ---- product-handle fallback (used only when no SKU is available on the DOM) ----
  function getProductHandleFromDOM(){
    var form = document.querySelector(".booking-form[data-product-handle]");
    return form ? (form.getAttribute("data-product-handle") || "") : "";
  }
  function keysFromHandle(handle){
    if (!handle || typeof handle !== "string") return [];
    var h = handle.toLowerCase();
    if (h.indexOf("mygreetings") > -1) return ["Mygreetings"];
    var keys = ["Myselfie"];
    if (h.indexOf("print") > -1 || h.indexOf("premium") > -1) keys.push("Printer");
    if (h.indexOf("greetings") > -1 || h.indexOf("lydg") > -1 || h.indexOf("premium") > -1) keys.push("Mygreetings");
    return keys;
  }
  // Components relevant to the product currently on screen: prefer the SKU-driven
  // PRODUCT_MAP mapping (handles bundles precisely), fall back to the handle heuristic
  // (e.g. "myselfie-print", "myselfie-premium", "mygreetings") when no SKU is present.
  function currentProductKeys(){
    var sku = getSelectedVariantSkuFromDOM();
    var keys = SKU.fromSku(sku);
    if (!keys.length) keys = keysFromHandle(getProductHandleFromDOM());
    return applyOverrides(keys);
  }
  // Low/sold-out status for a single ISO date, scoped to the current product's
  // components; a date is sold out when ANY relevant component is sold out.
  function dayStatusForDate(iso, parsed){
    var keys = currentProductKeys();
    if (!keys.length){
      return {
        soldOut: inRangesIso(iso, parsed.aggregate.sold_out),
        low:     inRangesIso(iso, parsed.aggregate.low)
      };
    }
    var soldOut = keys.some(function(k){ var cfg = parsed.products[k]; return cfg && inRangesIso(iso, cfg.sold_out); });
    var low     = !soldOut && keys.some(function(k){ var cfg = parsed.products[k]; return cfg && inRangesIso(iso, cfg.low); });
    return { soldOut: soldOut, low: low };
  }

  function applyOverrides(keys){
    var keep = new Set(keys);
    keys.forEach(function(k){
      var cfg = keyConfig(k);
      if (!cfg || !cfg.overrides || !Array.isArray(cfg.overrides.ignoreFor)) return;
      cfg.overrides.ignoreFor.forEach(function(ignored){
        if (keep.has(ignored)) keep.delete(ignored);
      });
    });
    return Array.from(keep);
  }

  // ---- availability parsing ----
  function parseRanges(ranges){
    ranges = Array.isArray(ranges)? ranges : [];
    return ranges.map(function(r){ return { s: Date.parse(r.start), e: Date.parse(r.end) }; })
                 .filter(function(x){ return isFinite(x.s) && isFinite(x.e) && x.s<=x.e; });
  }
  function inRangesMs(ms, rs){ for (var i=0;i<rs.length;i++){ var R=rs[i]; if (ms>=R.s && ms<=R.e) return true; } return false; }
  function inRangesIso(iso, rs){ return inRangesMs(isoToMs(iso), rs); }

  // ---- endpoint (no headers, no caching) ----
  function fetchAvailability(cb){
    var shop = (window.Shopify && Shopify.shop) ? Shopify.shop.split(".")[0] : "";
    var url  = "https://api.myselfie.com/public/v1/" + shop + "/bookedDatesAvailability";
    var req = new XMLHttpRequest();
    req.open("GET", url, true);
    req.onreadystatechange = function(){
      if (req.readyState !== 4) return;
      if (req.status >= 200 && req.status < 300) {
        try { cb(null, JSON.parse(req.responseText)); }
        catch(e){ cb(new Error("Invalid JSON")); }
      } else cb(new Error("Availability fetch failed: " + req.status));
    };
    req.send(null);
  }

  // ---- UI helpers ----
  // Low-capacity/sold-out day colouring and the legend live in datepick-wdn.css
  // (.wdn-low / .wdn-booked / .wdn-legend). This only injects the small
  // "locked input" style, which has no static-CSS home.
  function injectLowCapacityCss(){
    var css = [
      DATE_INPUT_SELECTOR + ".msf-locked{",
      "  cursor:not-allowed !important;",
      "  background:#f7f7f7 !important;",
      "  color:#777 !important;",
      "}"
    ].join("");

    var el = document.getElementById("msf-lowcap-style");
    if (el) el.textContent = css;
    else {
      el = document.createElement("style");
      el.id = "msf-lowcap-style";
      el.type = "text/css";
      el.appendChild(document.createTextNode(css));
      document.head.appendChild(el);
    }
  }

  function saveDate(ddmmyy){
    if(!ddmmyy) return;
    try {
      sessionStorage.setItem("wdn_bookingdate", ddmmyy);
      document.dispatchEvent(new CustomEvent("datepicker:saved",{detail:{selectedDate:ddmmyy}}));
    } catch(e){}
  }
  function readSavedDate(){ try { return sessionStorage.getItem("wdn_bookingdate") || ""; } catch(e){ return ""; } }
  function isLocked(){ try { return sessionStorage.getItem(LOCK_FLAG) === "1"; } catch(e){ return false; } }
  function setLocked(on){ try { sessionStorage.setItem(LOCK_FLAG, on ? "1" : "0"); } catch(e){} }

  function lockDatepickerToISO(iso){
    if (!$) return;
    var $input = $(DATE_INPUT_SELECTOR);
    if (!$input.length) return;

    var ddm = (function(){ var d=new Date(iso); if(isNaN(d)) return ""; return dateToDdMmYy(d); })();
    if (ddm) { $input.val(ddm); saveDate(ddm); }

    var el = $input[0];
    el.readOnly = true;
    el.classList.add("msf-locked");
    el.setAttribute("aria-readonly","true");
    el.title = el.title || "Date locked for your cart to avoid mismatches";

    function stop(e){ e.preventDefault(); e.stopPropagation(); el.blur(); return false; }
    if (!el._msfLockHandlers) {
      el._msfLockHandlers = true;
      el.addEventListener("mousedown", stop, true);
      el.addEventListener("focus", stop, true);
      el.addEventListener("keydown", stop, true);
    }
    setLocked(true);
  }

  function unlockDatepicker(){
    if (!$) return;
    var $input = $(DATE_INPUT_SELECTOR);
    if (!$input.length) return;
    var el = $input[0];
    el.readOnly = false;
    el.classList.remove("msf-locked");
    el.removeAttribute("aria-readonly");
    el.removeAttribute("title");
    // drop any lock listeners by cloning node
    if (el._msfLockHandlers){
      var clone = el.cloneNode(true);
      el.parentNode.replaceChild(clone, el);
    }
    setLocked(false);
  }

  // Observer that strictly maps the body's .sold-out class to the AddToCart button's disabled state
  function bindBodyClassToAddToCart() {
    function syncButton() {
      var isSoldOut = document.body.classList.contains("sold-out");
      var btn = document.getElementById("AddToCart");
      if (btn) {
        btn.disabled = isSoldOut;
        btn.classList.toggle("disabled", isSoldOut);
      }
    }

    // Run once on load to catch initial state
    syncButton();

    // Watch the body tag for any class attribute changes
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === "class") {
          syncButton();
        }
      });
    });
    
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }

  function navigateToPackages(){
    var anchor = document.getElementById("packages");
    if (anchor && anchor.scrollIntoView) anchor.scrollIntoView({behavior:"smooth", block:"start"});
    else { try{ window.location.hash="packages"; }catch(e){} setTimeout(function(){ if(!document.getElementById("packages")) window.location.href="/#packages"; },50); }
  }
  function hideBookingUI(){
    var wrap = document.querySelector(".booking-form-wrap") || document.querySelector(".booking-form");
    if (wrap) wrap.style.display="none";
  }
  function showBookingUI(){
    var wrap = document.querySelector(".booking-form-wrap") || document.querySelector(".booking-form");
    if (wrap) wrap.style.display="";
    var input = document.querySelector(DATE_INPUT_SELECTOR);
    if (input) input.setAttribute("required","required");
  }

  // ---- pricing cards ----
  function cardKeysFromDataSku(card){
    var raw = (card.getAttribute("data-sku") || "").toUpperCase();
    var parts = raw.split("+").map(function(s){return s.trim();}).filter(Boolean);
    var keys = new Set();
    parts.forEach(function(p){ var k = SKU.prefixToKey(p); if (k) keys.add(k); });
    return Array.from(keys);
  }

  function updatePricingCardsForDate(dateISO, parsed){
    var cards = document.querySelectorAll(".pricing-container .pricing-card[data-sku]");
    if (!cards || !cards.length || !dateISO || !parsed) return;

    cards.forEach(function(card){
      var keys = cardKeysFromDataSku(card);
      var fixed = SKU.fixedDateFromSku(card.getAttribute("data-sku")||"");
      var soldOut=false, low=false;

      if (fixed) {
        soldOut = (dateISO !== dateToIso(fixed));
      } else {
        var effKeys = applyOverrides(keys);
        soldOut = effKeys.some(function(k){ return inRangesIso(dateISO, parsed.products[k].sold_out); });
        low     = !soldOut && effKeys.some(function(k){ return inRangesIso(dateISO, parsed.products[k].low); });
      }
      card.classList.toggle("sold-out", !!soldOut);
      card.classList.toggle("low-capacity", !!low);
    });
  }

  // ---- product (current variant) enforcement ----
  function getSelectedVariantSkuFromDOM(){
    var sel = document.getElementById("productSelect");
    if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
      var s = sel.selectedOptions[0].getAttribute("data-sku");
      if (s) return s;
    }
    var checked = document.querySelector('input[type="radio"][name="id"]:checked');
    if (checked){
      var s2 = checked.getAttribute("data-sku");
      if (s2) return s2;
    }
    var form = document.querySelector(".booking-form");
    if (form) {
      var b = form.getAttribute("data-bundle-sku"); if (b) return b;
      var p = form.getAttribute("data-product-sku"); if (p) return p;
    }
    return "";
  }

  function enforceCurrentProductForDate(dateISO, parsed){
    var bodyCls = document.body.classList;
    
    if (!dateISO || !parsed){ 
      bodyCls.remove("sold-out", "low-inventory");
      return; 
    }

    var sku = getSelectedVariantSkuFromDOM();
    if (!sku) return;

    var fixed = SKU.fixedDateFromSku(sku);
    var isBlocked = false;
    var isLow = false;

    if (fixed){
      var ok = (dateISO === dateToIso(fixed)) && (new Date() < new Date(dateISO));
      isBlocked = !ok;
    } else {
      var keys = SKU.fromSku(sku);
      var eff  = applyOverrides(keys);
      isBlocked = eff.some(function(k){ return inRangesIso(dateISO, parsed.products[k].sold_out); });
      isLow = !isBlocked && eff.some(function(k){ return inRangesIso(dateISO, parsed.products[k].low); });
    }

    // Simply tag the body. The MutationObserver will instantly lock/unlock the Add To Cart button
    bodyCls.toggle("sold-out", !!isBlocked);
    bodyCls.toggle("low-inventory", !!isLow);

    if (isBlocked) navigateToPackages();
  }

  // ---- datepicker setup ----
  function calcMinDateFromAggregateSoldOut(parsed){
    var curSku = getSelectedVariantSkuFromDOM();
    if (SKU.fromSku(curSku).indexOf("GallerySA") > -1) return 0;

    var today = new Date();
    var cursor = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var end    = new Date(today.getFullYear(), today.getMonth()+1, 0);
    var daysUntilEnd = end.getDate() - today.getDate();

    for (var i=1;i<=daysUntilEnd;i++){
      cursor.setDate(cursor.getDate()+1);
      var iso = dateToIso(cursor);
      if (!inRangesIso(iso, parsed.aggregate.sold_out)) return 0;
    }
    return daysUntilEnd + 1;
  }

  function initDatepicker(parsed){
    injectLowCapacityCss();

    var $input = $(DATE_INPUT_SELECTOR);
    if (!$input.length) return;

    var fixed = SKU.fixedDateFromSku(getSelectedVariantSkuFromDOM());
    if (fixed){
      var ddmmyy = dateToDdMmYy(fixed);
      $input.val(ddmmyy);
      saveDate(ddmmyy);
      hideBookingUI();
      var iso = dateToIso(fixed);
      updatePricingCardsForDate(iso, parsed);
      enforceCurrentProductForDate(iso, parsed);
      return;
    }

    showBookingUI();

    function beforeShowDay(date){
      var curSku = getSelectedVariantSkuFromDOM();
      if (SKU.fromSku(curSku).indexOf("GallerySA") > -1) {
        return [true, "", ""];
      }
      var iso = $.datepicker.formatDate(API_FMT, date);
      var status = dayStatusForDate(iso, parsed);
      if (status.soldOut) return [false, "wdn-booked", "Fuldt booket"];
      if (status.low)     return [true, "wdn-low", "Få tilbage på denne dato"];
      return [true, "", ""];
    }

    // Legend ("Ledig / Få tilbage / Fuldt booket") appended under the calendar.
    // jQuery UI's _updateDatepicker() rewrites #ui-datepicker-div's children on
    // every month/year change, so a MutationObserver re-adds the legend as needed
    // instead of relying on a single one-off insertion.
    var legendObserverStarted = false;
    function ensureLegend(){
      var container = document.getElementById("ui-datepicker-div");
      if (!container || container.querySelector(".wdn-legend")) return;
      var legend = document.createElement("div");
      legend.className = "wdn-legend";
      legend.innerHTML =
        '<span class="wdn-legend-item wdn-legend-available">' + "Ledig" + "</span>" +
        '<span class="wdn-legend-item wdn-legend-low">' + "Få tilbage" + "</span>" +
        '<span class="wdn-legend-item wdn-legend-booked">' + "Fuldt booket" + "</span>";
      container.appendChild(legend);
    }
    function watchLegend(){
      var container = document.getElementById("ui-datepicker-div");
      if (!container) return;
      ensureLegend();
      if (legendObserverStarted) return;
      legendObserverStarted = true;
      var obs = new MutationObserver(function(){ ensureLegend(); });
      obs.observe(container, { childList: true });
    }

    var dpConfig = {
      minDate: calcMinDateFromAggregateSoldOut(parsed),
      maxDate: "3Y",
      dateFormat: "dd/mm/yy",
      firstDay: 1,
      dayNamesMin: (window.Translations && Translations.datepicker && Translations.datepicker.dayNamesMin) || ["S","M","T","W","T","F","S"],
      monthNamesShort: (window.Translations && Translations.datepicker && Translations.datepicker.monthNameShort) || ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
      beforeShowDay: beforeShowDay,
      beforeShow: function(){ setTimeout(watchLegend, 0); },
      onSelect: function(selected){
        // Save only; DO NOT LOCK on first selection
        saveDate(selected);
        var iso = ddmmyyToIso(selected);
        updatePricingCardsForDate(iso, parsed);
        enforceCurrentProductForDate(iso, parsed);
      }
    };

    try { if ($input.hasClass("hasDatepicker")) { $input.datepicker("destroy"); } } catch(e){}
    $input.datepicker(dpConfig);

    // If cart already has a date -> lock to that date; else leave unlocked
    enforceAndMaybeLockFromCart(parsed, function(lockedISO){
      if (lockedISO){
        lockDatepickerToISO(lockedISO);
        updatePricingCardsForDate(lockedISO, parsed);
        enforceCurrentProductForDate(lockedISO, parsed);
      } else {
        // No cart date -> ensure unlocked, but honor any saved date for convenience
        unlockDatepicker();
        var existing = readSavedDate();
        if (existing){
          $input.datepicker("setDate", existing);
          var iso = ddmmyyToIso(existing);
          updatePricingCardsForDate(iso, parsed);
          enforceCurrentProductForDate(iso, parsed);
        }
      }
    });

    function onVariantChange(){
      var fixedNow = SKU.fixedDateFromSku(getSelectedVariantSkuFromDOM());
      if (fixedNow){
        var ddm = dateToDdMmYy(fixedNow);
        $input.val(ddm);
        saveDate(ddm);
        hideBookingUI();
        var iso = dateToIso(fixedNow);
        updatePricingCardsForDate(iso, parsed);
        enforceCurrentProductForDate(iso, parsed);
      } else {
        showBookingUI();
        // Keep current (un)locked state; if cart has a date it will already be locked
        var dd = readSavedDate();
        if (dd){ updatePricingCardsForDate(ddmmyyToIso(dd), parsed); enforceCurrentProductForDate(ddmmyyToIso(dd), parsed); }
      }
    }

    document.addEventListener("change", function(e){
      if (e.target && (e.target.id==="productSelect" || e.target.name==="id")) onVariantChange();
    });
    if (typeof window.selectCallback === "function"){
      var _orig = window.selectCallback;
      window.selectCallback = function(variant, selector){
        try{ _orig(variant, selector); }catch(e){}
        onVariantChange();
      };
    }

    // Keep reacting to saved events, but DO NOT lock here
    document.addEventListener("datepicker:saved", function(e){
      var ddmmyy = e.detail && e.detail.selectedDate;
      var iso = ddmmyyToIso(ddmmyy);
      if (iso){
        updatePricingCardsForDate(iso, parsed);
        enforceCurrentProductForDate(iso, parsed);
      }
    });
  }

  // ---- cart helpers ----
  function allowCartSubmission(){
    var btns = document.querySelectorAll('[name="checkout"]');
    btns.forEach(function(b){ b.disabled=false; });
    if (document.body.getAttribute("data-cart-page-invalid") === "too_many") {
      document.body.removeAttribute("data-cart-page-invalid");
    }
  }
  function disallowCartSubmission(){
    var btns = document.querySelectorAll('[name="checkout"]');
    btns.forEach(function(b){ b.disabled=true; });
  }

  function fetchCart(cb){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    var url  = root + "cart.js";
    var xh = new XMLHttpRequest();
    xh.open("GET", url, true);
    xh.onreadystatechange = function(){
      if (xh.readyState===4){
        if (xh.status>=200 && xh.status<300){
          try { cb(null, JSON.parse(xh.responseText)); } catch(e){ cb(e); }
        } else cb(new Error("cart fetch failed"));
      }
    };
    xh.send(null);
  }

  function cartItemRequiresDate(sku){
    if (!sku) return false;
    if (SKU.fixedDateFromSku(sku)) return true;
    var keys = SKU.fromSku(sku);
    return keys.some(function(k){
      var cfg = keyConfig(k);
      return cfg && !!cfg.requiresDate;
    });
  }

  function clearCartNow(){
    try { sessionStorage.removeItem("wdn_bookingdate"); } catch(e){}
    setLocked(false);

    try {
      if (window.WDN && WDN.Cart && typeof WDN.Cart.Clear === "function") {
        return WDN.Cart.Clear({ onSuccess: function(){ window.location.reload(); } });
      }
    } catch(e){}
    try {
      var x = new XMLHttpRequest();
      x.open("POST", (Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart/clear.js", true);
      x.setRequestHeader("Content-Type","application/json;charset=UTF-8");
      x.onreadystatechange = function(){ if (x.readyState===4){ window.location.reload(); } };
      x.send("{}");
    } catch(e){
      window.location.href = "/cart/clear";
    }
  }

  function countKeys(cart){
    var counts = {};
    PRODUCT_MAP.forEach(function(p){ counts[p.key]=0; });
    var items = (cart && cart.items) || [];
    items.forEach(function(it){
      if (!it || !it.sku) return;
      var qty = Math.max(1, it.quantity || 1);
      var keys = SKU.fromSku(it.sku);
      keys.forEach(function(k){
        if (!counts.hasOwnProperty(k)) counts[k]=0;
        counts[k] += qty;
      });
    });
    return counts;
  }

  function exceedsLimits(cart){
    var counts = countKeys(cart);
    for (var i=0;i<PRODUCT_MAP.length;i++){
      var cfg = PRODUCT_MAP[i];
      if (cfg.limit==null) continue;
      var c = counts[cfg.key] || 0;
      if (c > cfg.limit) return { exceeded:true, key: cfg.key, count:c, limit:cfg.limit };
    }
    return { exceeded:false, counts: counts };
  }

  function collectCartDateState(cart){
    var items = (cart && cart.items) || [];
    var result = { requiring: [], datesISO: new Set(), fixedISO: new Set(), missingDateItems: [] };

    items.forEach(function(it){
      if (!it || !it.sku) return;
      if (!cartItemRequiresDate(it.sku)) return;

      result.requiring.push(it);

      var fixed = SKU.fixedDateFromSku(it.sku);
      if (fixed) result.fixedISO.add(dateToIso(fixed));

      var dateStr = it.properties && it.properties.Date;
      if (dateStr) {
        var iso = ddmmyyToIso(dateStr);
        if (iso) result.datesISO.add(iso);
        else result.missingDateItems.push(it);
      } else {
        result.missingDateItems.push(it);
      }
    });

    return result;
  }

  function ensureSingleDate(cart){
    var state = collectCartDateState(cart);
    if (state.requiring.length === 0) return { ok:true };

    if (state.fixedISO.size > 1) return { ok:false, reason:"fixed_mismatch" };

    var fixed = (state.fixedISO.size === 1) ? Array.from(state.fixedISO)[0] : "";
    if (!fixed && state.datesISO.size > 1) return { ok:false, reason:"mismatch" };
    if (!fixed && state.datesISO.size === 0) return { ok:false, reason:"missing_date" };

    if (fixed && state.datesISO.size > 0) {
      var onlyProvided = Array.from(state.datesISO)[0];
      if (onlyProvided !== fixed) return { ok:false, reason:"fixed_mismatch" };
    }
    if (state.missingDateItems.length > 0) return { ok:false, reason:"missing_date" };

    var shared = fixed || Array.from(state.datesISO)[0];
    var todayISO = dateToIso(new Date());
    if (shared !== todayISO && new Date() >= new Date(shared)) return { ok:false, reason:"past" };
    return { ok:true, sharedISO: shared };
  }

  function allItemsAllowedForDate(parsed, cart, sharedISO){
    var items = (cart && cart.items) || [];
    // The cart is checked as one booking, like a combined M-…+MYP-… bundle line: every dated
    // line is checked against all rental products in the cart after overrides. So a separate
    // printer line (MYP-, e.g. from the homepage product selector) earmarks the booth on another
    // line (PRODUCT_MAP: Printer ignores Myselfie's sold-out), and the printer's own
    // availability is checked even though a printer line on its own does not require a date.
    var cartKeys = [];
    items.forEach(function(it){
      if (!it || !it.sku) return;
      SKU.fromSku(it.sku).forEach(function(k){ if (cartKeys.indexOf(k) < 0) cartKeys.push(k); });
    });
    var cartEff = applyOverrides(cartKeys);
    for (var i=0;i<items.length;i++){
      var it = items[i];
      if (!it || !it.sku) continue;
      if (!cartItemRequiresDate(it.sku)) continue;

      if (SKU.fixedDateFromSku(it.sku)) continue; // fixed overrides availability

      var eff  = cartEff;
      var blocked = eff.some(function(k){ return inRangesIso(sharedISO, parsed.products[k].sold_out); });
      if (blocked) return { ok:false, item:it };
    }
    return { ok:true };
  }

  function setTooManyFlag(on){
    if (on){
      document.body.setAttribute("data-cart-page-invalid", "too_many");
      disallowCartSubmission();
    } else {
      if (document.body.getAttribute("data-cart-page-invalid") === "too_many") {
        document.body.removeAttribute("data-cart-page-invalid");
      }
    }
  }

  // Lock from CART if a shared date exists (used on product page init)
  function enforceAndMaybeLockFromCart(parsed, done){
    fetchCart(function(err, cart){
      if (err){ console.warn("[api-dates] cart error", err); done(""); return; }

      var single = ensureSingleDate(cart);
      if (!single.ok){
        // Auto-clear mismatches (no prompt)
        if (single.reason === "mismatch" || single.reason === "fixed_mismatch") {
          clearCartNow();
          done("");
          return;
        }
        // Missing/past -> don't lock, let user pick freely
        done("");
        return;
      }
      if (single.sharedISO){
        lockDatepickerToISO(single.sharedISO); // lock UI to CART date
        done(single.sharedISO);
        return;
      }
      done("");
    });
  }

  function validateCart(parsed){
    if (!isCartPage()) return;

    fetchCart(function(err, cart){
      if (err){ console.warn("[api-dates] cart error", err); return; }

      var limitStatus = exceedsLimits(cart);
      if (limitStatus.exceeded) {
        setTooManyFlag(true);
        return;
      } else setTooManyFlag(false);

      var single = ensureSingleDate(cart);
      if (!single.ok){
        if (single.reason === "mismatch" || single.reason === "fixed_mismatch") {
          clearCartNow(); // auto-clear, no prompt
          return;
        }
        disallowCartSubmission();
        return;
      }

      var per = allItemsAllowedForDate(parsed, cart, single.sharedISO);
      if (!per.ok){ disallowCartSubmission(); return; }

      allowCartSubmission();
    });
  }

  // ---- Redirects: pure Myselfie only (no D-, no '+') ----
  (function DatepickerRedirect(){
    // Prefer all-families dump so we don't depend on per-page range snippets
    var allFamiliesEl = document.querySelector('[data-all-date-families="true"]');
    if (!allFamiliesEl) return;
    var families = []; try { families = JSON.parse(allFamiliesEl.innerText) || []; } catch(e){ return; }

    function currentHandle(){
      if (window.meta && window.meta.product && window.meta.product.handle) return window.meta.product.handle;
      var path = (location.pathname || "").replace(/\/+$/,"");
      var parts = path.split("/");
      var idx = parts.indexOf("products");
      if (idx>=0 && parts[idx+1]) return parts[idx+1];
      return "";
    }

    var handle = currentHandle();
    if (!handle) return;

    function familyForHandle(h){
      for (var i=0;i<families.length;i++){
        var fam = families[i] || {};
        if (!fam || !fam.family) continue;
        var master = fam.master || "";
        var fallback = fam.fallback || "";
        if (h === master || h === fallback) return fam;
        var rs = Array.isArray(fam.ranges) ? fam.ranges : [];
        for (var j=0;j<rs.length;j++){
          if (rs[j] && rs[j].handle === h) return fam;
        }
      }
      return null;
    }

    var fam = familyForHandle(handle);
    if (!fam) return;

    console.log("[api-dates] redirect context", {
      handle: handle,
      family: fam.family,
      ranges: fam.ranges
    });

    var fallbackProductHandle = fam.fallback || "";
    var fallbackProductSource = fallbackProductHandle ? ("/products/" + fallbackProductHandle) : "/";

    // Normalize ranges: accept {start,end,handle} or {dates:"YYYY-MM-DD---YYYY-MM-DD", handle:"..."}
    var ranges = (Array.isArray(fam.ranges) ? fam.ranges : []).map(function(r){
      if (!r || !r.handle) return null;
      var start = r.start, end = r.end;
      if ((!start || !end) && r.dates && typeof r.dates === "string" && r.dates.indexOf("---")>-1){
        var parts = r.dates.split("---");
        start = (parts[0] || "").trim();
        end   = (parts[1] || "").trim();
      }
      if (!start || !end) return null;
      var dest = "/products/" + r.handle;
      return { start: start, end: end, target_product_handle: r.handle, target_destination: dest };
    }).filter(Boolean);

    function plusYears(range, years){
      var s=new Date(range.start), e=new Date(range.end);
      if (!(s<=e)) return null;
      var all=[], sY=s.getFullYear(), eY=e.getFullYear();
      for (var i=0;i<=years;i++){
        var ss=new Date(s); ss.setFullYear(sY+i);
        var ee=new Date(e); ee.setFullYear(eY+i);
        all.push({s:ss, e:ee});
      }
      return { ranges: all, target_product_handle: range.target_product_handle, target_destination: range.target_destination };
    }
    var rlist = ranges.map(function(r){return plusYears(r,0);}).filter(Boolean);

    var redirected=false;
    function redirectTo(href){ if(!redirected && href){ redirected=true; window.location.href=href; } }
    function findByDate(ddmmyy){
      var ymd = ddmmyy.replace(/\//g, "-").split("-").reverse().join("-");
      var ts = Date.parse(ymd);
      for(var i=0;i<rlist.length;i++){
        var hit = rlist[i].ranges.some(function(R){ return ts>=R.s && ts<=R.e; });
        if (hit) return rlist[i];
      }
      return null;
    }
    function checkAndMaybeRedirect(ddmmyy){
      if (!ddmmyy) return;
      var match = findByDate(ddmmyy);
      if (!match){
        if (handle !== fallbackProductHandle) redirectTo(fallbackProductSource);
        return;
      }
      if (match.target_product_handle !== handle) redirectTo(match.target_destination);
    }

    // Page-load enforcement using any saved date (session storage or prefilled input)
    try {
      var saved = sessionStorage.getItem("wdn_bookingdate") || "";
      checkAndMaybeRedirect(saved);
    } catch(e){}
    var input = document.querySelector("#productpage-booking-start");
    if (input && input.value) checkAndMaybeRedirect(input.value);

    document.addEventListener("datepicker:saved", function(e){
      var ddmmyy = e.detail && e.detail.selectedDate;
      checkAndMaybeRedirect(ddmmyy);
    });
  })();

  // ---- Boot ----
  function boot(){
    bindBodyClassToAddToCart(); // Start the observer immediately
    
    fetchAvailability(function(err, payload){
      if (err){ console.warn("[api-dates] availability error", err); return; }

      var parsedProducts = {};
      PRODUCT_MAP.forEach(function(cfg){
        var p = (payload.products && payload.products[cfg.key]) || {};
        parsedProducts[cfg.key] = {
          sold_out: parseRanges(p.sold_out || []),
          low:      parseRanges(p.low      || [])
        };
      });

      var parsed = {
        aggregate: {
          sold_out: parseRanges((payload.aggregate && payload.aggregate.sold_out) || []),
          low:      parseRanges((payload.aggregate && payload.aggregate.low)      || [])
        },
        products: parsedProducts
      };

      if (HAS_JQUERY_UI && document.querySelector(DATE_INPUT_SELECTOR)) {
        initDatepicker(parsed);
      }

      /* ---- Pricing cards on pages without the product picker -----------------
         The .pricing-card[data-sku] cards (sections/price-packages-container-index)
         live on the home page, which has no #productpage-booking-start, so
         initDatepicker() - and with it the old "datepicker:saved" listener and the
         first updatePricingCardsForDate() call - never ran there. Wire the cards up
         here instead, independently of the product picker:
           - "myselfie:date"     -> global header picker (assets/myselfie-header.js),
                                    detail {iso, display}
           - "datepicker:saved"  -> product picker / saveDate(), detail {selectedDate}
           - sessionStorage      -> a date picked earlier in the session is applied on load
         updatePricingCardsForDate() is idempotent, so the duplicate listener on
         product pages is harmless. Exposed as window.MyselfieDates for other scripts. */
      function refreshCardsForIso(iso){
        if (iso) updatePricingCardsForDate(iso, parsed);
      }
      document.addEventListener("myselfie:date", function(e){
        var d = (e && e.detail) || {};
        refreshCardsForIso(d.iso || ddmmyyToIso(d.display || ""));
      });
      document.addEventListener("datepicker:saved", function(e){
        var d = (e && e.detail) || {};
        refreshCardsForIso(ddmmyyToIso(d.selectedDate || ""));
      });
      window.MyselfieDates = window.MyselfieDates || {};
      window.MyselfieDates.availability = parsed;
      window.MyselfieDates.updatePricingCards = function(iso){ refreshCardsForIso(iso); };
      refreshCardsForIso(ddmmyyToIso(readSavedDate()));

      // Cart enforcement ONLY on cart page
      validateCart(parsed);
      document.addEventListener("change", function(e){
        if (!isCartPage()) return;
        if (e.target && (e.target.name==="id" || e.target.id==="Quantity")) validateCart(parsed);
      });
      document.body.addEventListener("cart:updated", function(){ if (isCartPage()) validateCart(parsed); });
      document.body.addEventListener("cart:added",   function(){ if (isCartPage()) validateCart(parsed); });
      document.body.addEventListener("cart:changed", function(){ if (isCartPage()) validateCart(parsed); });
    });
  }

  if (document.readyState==="loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();